var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2999 8.64943L9.47491 7.82448L10.2999 6.99953C11.2111 6.0883 11.2111 4.61092 10.2999 3.69969C9.38864 2.78847 7.91123 2.78847 7 3.69969L6.17505 4.52465L5.3501 3.69969L6.17505 2.87474C7.54186 1.5079 9.75795 1.5079 11.1248 2.87474C12.4916 4.24157 12.4916 6.45767 11.1248 7.82448L10.2999 8.64943ZM8.6499 10.2994L7.82495 11.1243C6.45815 12.4911 4.24206 12.4911 2.87523 11.1243C1.50839 9.75747 1.50839 7.54139 2.87523 6.17458L3.70018 5.34961L4.52514 6.17458L3.70018 6.99953C2.78896 7.91075 2.78896 9.38816 3.70018 10.2994C4.61141 11.2106 6.08878 11.2106 7 10.2994L7.82495 9.47438L8.6499 10.2994ZM8.6499 4.52465L9.47491 5.34961L5.3501 9.47438L4.52514 8.64943L8.6499 4.52465Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/linkIcon.0b151229.svg";
export { ForwardRef as ReactComponent };